import { render, staticRenderFns } from "./modelDesign.vue?vue&type=template&id=88599c04&scoped=true"
import script from "./modelDesign.vue?vue&type=script&lang=js"
export * from "./modelDesign.vue?vue&type=script&lang=js"
import style0 from "./modelDesign.vue?vue&type=style&index=0&id=88599c04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88599c04",
  null
  
)

export default component.exports